import type {DataGridRow} from '@dms/api/core';

import {DATA_GRID_STRING_VALUE_SCHEMA, readDataGridCell} from './readDataGridCell';

export function readDataGridCellString(row: DataGridRow, keys: readonly string[]) {
  const result = DATA_GRID_STRING_VALUE_SCHEMA.safeParse(readDataGridCell(row, keys));

  return result.success ? result.data : undefined;
}
